const useShowBanner = (startDate: string, rangeInMonths = 3) => {
  if (!startDate) return false

  const start = new Date(startDate)
  const end = new Date(start)
  end.setMonth(end.getMonth() + rangeInMonths)

  return new Date() <= end
}

export default useShowBanner
